export const testAttributes = {
    MODAL_CONTAINER: 'modal_container',
    MODAL_CONTENT_WRAPPER: 'modal_content_wrapper',
    MODAL_CONTENT: 'modal_content',
    CLOSE_ICON: 'modal_close_icon',

}